<div class="row">
  <div class="col-5 my-auto mx-auto bg-white p-3 rounded border-top border-primary">
    <div class="row">
      <div class="col-12 text-center">
        <h3 class="text-primary">กรุณาเปลี่ยนรหัสผ่านใหม่</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="newPass">รหัสผ่านใหม่</label>
          <input type="password" class="form-control" name="newPass" [(ngModel)]="newPass">
          <span class="text-danger" *ngIf="submitted && newPass.trim() == ''">
            กรุณาระบุ รหัสผ่านใหม่
          </span>
          <span class="text-danger" *ngIf="submitted && newPass.trim() != '' && passwordValidation() == false">
            รหัสผ่านใหม่ต้องประกอบไปด้วย<br> อักษรภาษาอังกฤษตัวเล็กอย่างน้อย 1 ตัว<br> ตัวใหญ่อย่างน้อย 1 ตัว<br>
            ตัวเลขอย่างน้อย 1 ตัว<br> อักขระพิเศษอย่างน้อย 1 ตัว<br> ขั้นต่ำ 8 ตัวอักษรและไม่เกิน 16 ตัวอักษร
          </span>
        </div>
        <div class="form-group">
          <label for="confirmNewPass">ยืนยันรหัสผ่าน</label>
          <input type="password" class="form-control" name="confirmNewPass" [(ngModel)]="confirmPass">
          <span class="text-danger" *ngIf="submitted && confirmPass.trim() != '' && confirmPass != newPass">
            กรุณาระบุ ยืนยันรหัสผ่านใหม่ ให้ตรงกับ รหัสผ่านใหม่
          </span>
        </div>
        <div class="form-group mt-3 pl-3">
          <span class="text-secondary">
            1. ตั้งรหัสผ่านใหม่ เป็นภาษาอังกฤษความยาว 8 ถึง 16 ตัวอักษร<br>
            2. โดยจะต้องมีตัวอีกษรตัวใหญ่(A-Z)และตัวเล็ก(a-z)<br>
            3. ตัวเลข(0-9)และอักขระพิเศษ(!,@,....)ผสมกัน
          </span>
        </div>

      </div>
      <div class="col-12 text-center">
        <button type="button" class="btn btn-primary m-2" id="btnSave" (click)="resetPassword()">บันทึก</button>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.html